import { Injectable } from '@angular/core';
import { BackendService } from '..';

@Injectable({
  providedIn: 'root'
})
export class TestbatchService {


  private path = "/test-batch";

  constructor(private backendService: BackendService) {}


  getAll  (){
    return this.backendService.get (this.path);
  }

  getOne(id){
    return this.backendService.get(this.path + "/" + id);
  }

  save (data){
    return this.backendService.post (this.path, data);
  }
   
  deleteData (id){
    return this.backendService.post (this.path + "/" + id + "/delete", {});
  }
}
